import { CSSObject } from 'styled-components';
import { theme } from '../theme/theme';

export type TypographyVariant = Exclude<keyof typeof theme.typography, 'fontFamily'>;

export const typography = (variant: TypographyVariant): CSSObject => {
  const style = theme.typography[variant];
  if (typeof style === 'string') {
    return {
      fontFamily: style,
    };
  }
  return {
    fontSize: style.fontSize,
    fontWeight: style.fontWeight,
    lineHeight: style.lineHeight,
    ...('textTransform' in style && { textTransform: style.textTransform as 'uppercase' | 'lowercase' | 'capitalize' | 'none' }),
  };
};
